import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './InitialLoadProgress.module.css';
import ProgressBar from './ProgressBar';
var API_LOADED_PROGRESS = 1 / 3;
export default function InitialLoadProgress(_a) {
    var isPro = _a.isPro, companyColour = _a.companyColour, noOfImagesToPreload = _a.noOfImagesToPreload, noOfImagesLoaded = _a.noOfImagesLoaded;
    var backgroundStyle = cx(styles.background, {
        'bg-smoke': isPro,
        'bg-white': !isPro,
    });
    var foregroundStyle = cx(styles.foreground, !companyColour && {
        'bg-green--l': isPro,
        'bg-blue--l': !isPro,
    }, companyColour && styles.companyColor);
    return (React.createElement("div", { className: backgroundStyle },
        React.createElement(ProgressBar, { completedStep: noOfImagesLoaded, initialProgress: API_LOADED_PROGRESS, noOfSteps: noOfImagesToPreload },
            React.createElement("div", { className: foregroundStyle, style: companyColour ? { backgroundColor: "#".concat(companyColour) } : undefined }))));
}
InitialLoadProgress.propTypes = {
    isPro: PropTypes.bool.isRequired,
    companyColour: PropTypes.string,
    noOfImagesToPreload: PropTypes.number.isRequired,
    noOfImagesLoaded: PropTypes.number.isRequired,
};
